import styled from "styled-components"

export const Container = styled.div`
    flex: 2;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    padding: 20px;
    border-radius: 10px;
`

export const Title = styled.h3`
`

export const Table = styled.table`
    width: 100%;
    border-spacing: 20px;
`

export const TableHeader = styled.th`
    text-align: left;
`

export const TableRow = styled.tr`
`

export const User = styled.td`
    display: flex;
    align-items: center;
`

export const Image = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
`

export const UserName = styled.span`
    font-weight: 600;
`

export const Date = styled.td`
    font-weight: 300;
`

export const Amount = styled.td`
    font-weight: 300;
`

export const Status = styled.td`
`

export const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 10px;
    padding: 7px 10px;
    width: 100px;
    background-color: var(--${props => props.buttonColor});
    color: var(--dark${props => props.buttonColor});
    cursor: pointer;
    font-weight: 600;
`